import React, { ReactElement } from 'react';
import { Box, BoxProps, Skeleton } from '@mui/material';

import { MainTokenIcon, StakeTokenIcon } from 'modules/common/icons';

interface ITokenIconProps extends Pick<BoxProps, 'sx' | 'className'> {
  token: string;
}

export function TokenIcon({
  token,
  className,
  sx,
}: ITokenIconProps): ReactElement {
  const Icon = getIconByTokenSymbol(token) || Skeleton;

  return (
    <Box
      className={className}
      component={Icon}
      sx={{ width: '1em', height: '1em', ...sx }}
      variant="circular"
    />
  );
}

function getIconByTokenSymbol(tokenSymbol: string) {
  switch (tokenSymbol) {
    case 'MAT':
      return MainTokenIcon;
    case 'stMAT':
      return StakeTokenIcon;
    default:
      return null;
  }
}
